import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';
const Header = styled.div.withConfig({
  displayName: "SectionHeader__Header",
  componentId: "d094bx-0"
})(["display:flex;flex-wrap:wrap;row-gap:4px;background:", ";color:", ";width:fill-available;align-items:center;padding:0 6px 1px;justify-content:space-between;min-height:31px;@media (max-width:599px){height:auto;}"], props => props.theme.palette.error.light, props => props.theme.palette.common.white);
const ActionDiv = styled.div.withConfig({
  displayName: "SectionHeader__ActionDiv",
  componentId: "d094bx-1"
})(["display:flex;align-items:center;align-self:center;flex-shrink:0;margin-right:-3px;"]);
const HeaderTitle = withStyles(() => createStyles({
  root: {
    position: 'relative',
    padding: '0 8px',
    lineHeight: 'normal',
    height: 'auto',
    textTransform: 'uppercase',
    fontSize: 'clamp(1rem, 3.5vw, 1.2rem)',
    flex: '1 1 120px',
    minWidth: 0
  }
}))(Typography);
export const SectionHeader = ({
  id,
  title,
  nav,
  TypographyProps,
  style
}) => /*#__PURE__*/React.createElement(Header, {
  id: "header",
  style: style
}, /*#__PURE__*/React.createElement(HeaderTitle, _extends({
  id: id,
  variant: "h6"
}, TypographyProps), "TASKS FOR ", title), /*#__PURE__*/React.createElement(ActionDiv, {
  id: "task-div"
}, nav));